export default {
  delete: {
    success: "Delete successfully",
    fail: "Delete failed",
  },
  duplicate: {
    success: "Duplicate successfully",
    fail: "Duplicate failed",
  },
  create: {
    success: "Create successfully",
    fail: "Create failed",
  },
  update: {
    success: "Update successfully",
    fail: "Update failed",
  },
  form_validate: {
    warning: "Some fields are invalid. Please check!",
  },
  reset_pass: {
    fail: "Reset password not successfully!",
    success: "Reset password successfully!",
  },
  sign_up: {
    success: "Sign up successfully!",
    fail: "Sign up not successfully!",
  },
  upload_image: {
    success: "Upload image successfully!",
    fail: "Upload image  fail!",
  },
  merge: {
    success: "Merge successfully! ",
    fail: "Merge suggestions fail!",
  },
  fetch: {
    success: "fetch data successfully!",
    fail: "Oops, something was wrong",
  },
  warning: {
    type: "Please type search value",
  },
  login: {
    success: "Login successfully",
  },
  otp: {
    fail: "OTP number is not correct",
  },
  download: {
    success: "Download successfully",
    fail: "Download was fail",
  },
  change: {
    success: "your password has beeen changed successfully",
    fail: "change password has fail",
  },
  send: {
    success: "otp code has beeen sent successfully",
    resend_success: "Coupon has beeen sent successfully",
  },
  info: {
    message:"The new feature will coming soon"
  }
};
